import React from "react";
import { useHistory, useLocation } from "react-router";

import { Container } from "@ui/Atoms";

import { ProfileLayoutFeatureToggleProps } from "./ProfileLayout.types";
import * as Styled from "./ProfileLayout.styled";

export const ProfileLayout: React.FC<
  ProfileLayoutFeatureToggleProps
> = props => {
  const history = useHistory();
  const location = useLocation();

  return (
    <React.Fragment>
      <Styled.Root>
        <Styled.TabsUnderline>
          <Container>
            <Styled.ProfileNavigationTabs>
              {props.tabs.map(tab => {
                return (
                  <Styled.ProfileNavigationTab
                    key={tab.to}
                    testId={tab.testId}
                    active={location.pathname === tab.to}
                    onClick={() => history.push(tab.to)}
                  >
                    {tab.icon && <tab.icon />}
                    {tab.label}
                  </Styled.ProfileNavigationTab>
                );
              })}
            </Styled.ProfileNavigationTabs>
          </Container>
        </Styled.TabsUnderline>

        <Container>
          <Styled.TabContent>{props.children}</Styled.TabContent>
        </Container>
      </Styled.Root>
    </React.Fragment>
  );
};
